import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../redux/Store';
import { RootReducerState } from '../redux/Reducers';
import { getOrganizationTheme } from '../features/shared/shared.action';
import { clearOrganizationTheme } from '../features/shared/shared.slice';
import { FETCH_STATUS } from '../types/enums/fetch-status.enum';
import { getDefaultOrganization } from '../utils/utilities';

export const useSynchronizeThemeStore = (): void => {
  const dispatch = useDispatch<AppDispatch>();

  const organizationTheme = useSelector((state: RootReducerState) => state.sharedReducer.organizationTheme);
  const organizationThemeFetchStatus = useSelector(
    (state: RootReducerState) => state.sharedReducer.organizationThemeFetchStatus
  );
  const selectedCompany = useSelector((state: RootReducerState) => state.sharedReducer.selectedCompany);
  const user = useSelector((state: RootReducerState) => state.authReducer.user);

  const effectiveId = getDefaultOrganization(selectedCompany, user)?.id ?? null;

  const lastRequestedId = useRef<number | null>(null);

  useEffect(() => {
    if (!user || !effectiveId) {
      lastRequestedId.current = null;
      if (organizationTheme) dispatch(clearOrganizationTheme());
      return;
    }
    if (organizationTheme?.id === effectiveId) {
      lastRequestedId.current = effectiveId;
      return;
    }
    if (organizationThemeFetchStatus === FETCH_STATUS.PENDING) return;
    if (lastRequestedId.current === effectiveId) return;
    lastRequestedId.current = effectiveId;
    dispatch(getOrganizationTheme(effectiveId));
  }, [user, effectiveId, dispatch, organizationTheme, organizationThemeFetchStatus]);
};
